import type { VisualPayload } from "../../types";
import CardShell from "./_CardShell";

interface Props { payload: VisualPayload }

export default function EmptyCard({ payload }: Props) {
  const sec = payload.sections.find((s) => s.section === "empty");
  const reason = sec?.reason as string | undefined;

  return (
    <CardShell title={payload.title || "No Data"} source={payload.data_source} timestamp={payload.data_timestamp} sourceUrl={payload.source_url} shareUrl={payload.share_url} snapshotPayload={payload.snapshot_eligible ? payload : undefined}>
      <div className="flex items-start gap-3 py-1">
        <span className="text-white/20 text-lg leading-none mt-0.5" aria-hidden="true">⊘</span>
        <p className="text-sm text-white/40 leading-relaxed">
          {reason ?? "No information available for this query."}
        </p>
      </div>
    </CardShell>
  );
}
